import { render, staticRenderFns } from "./Documentos.vue?vue&type=template&id=2fab9b4e&scoped=true"
import script from "./Documentos.vue?vue&type=script&lang=js"
export * from "./Documentos.vue?vue&type=script&lang=js"
import style0 from "./Documentos.vue?vue&type=style&index=0&id=2fab9b4e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fab9b4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fab9b4e')) {
      api.createRecord('2fab9b4e', component.options)
    } else {
      api.reload('2fab9b4e', component.options)
    }
    module.hot.accept("./Documentos.vue?vue&type=template&id=2fab9b4e&scoped=true", function () {
      api.rerender('2fab9b4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificaciones/infoBase/Documentos.vue"
export default component.exports